import { render, staticRenderFns } from "./dismissible_alert.vue.js?vue&type=template&id=6f2febda!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dismissible_alert.vue?vue&type=template&id=6f2febda"
import script from "./dismissible_alert.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dismissible_alert.vue?vue&type=script&lang=js"
export * from "./dismissible_alert.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dismissible_alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2febda')) {
      api.createRecord('6f2febda', component.options)
    } else {
      api.reload('6f2febda', component.options)
    }
    module.hot.accept("./dismissible_alert.vue.js?vue&type=template&id=6f2febda!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dismissible_alert.vue?vue&type=template&id=6f2febda", function () {
      api.rerender('6f2febda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/dismissible_alert.vue"
export default component.exports